import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useCta } from '~publish/hooks/useCta'

import { FLOW_TRACKING } from '../components/InsightsUpgradeDialog/flows'

const { cta: CTA, upgradePathName: UPGRADE_PATH_NAME } =
  FLOW_TRACKING['date-range']

type UseInsightsCustomDateUpgradeResult = {
  /**
   * Fires the upgrade CTA event and navigates to billing. Called from the
   * `InsightsUpgradeDialog`'s "See Upgrade Options" button — the dialog is
   * what now appears when a free user clicks the locked Custom date range.
   */
  handleUpgradeClick: () => void
}

export function useInsightsCustomDateUpgrade(): UseInsightsCustomDateUpgradeResult {
  const navigate = useNavigate()
  const cta = useCta(CTA, {
    upgradePathName: UPGRADE_PATH_NAME,
  })

  const handleUpgradeClick = useCallback((): void => {
    cta.clicked()
    navigate('/settings/billing')
  }, [cta, navigate])

  return { handleUpgradeClick }
}
